<template>
<a-modal
  centered
  :visible="visible"
  :title="null"
  :footer="null"
  :width="344"
  :closable="false"
  wrap-class-name="tag-modal"
  @change="$emit('change', $event)"
  destroy-on-close
  :maskClosable="false"
  :mask="false"
  :afterClose="handleReset"
>
  <div :class="tagModalClass">
    <a-input
      v-model.trim="searchVal"
      class="search-input"
      :placeholder="$t('common.Search')"
      @focus="tagModalClass=['active']"
      @blur="tagModalClass=[]"
      allowClear>
      <svg-icon slot="prefix" class-name="search" icon-class="search" />
    </a-input>
    <a-button class="add-btn" @click.native="addTag">
      <a-icon type="plus-circle" style="color: #236CFF;font-size: 14px"/>
      {{$t('home.AddType')}}
    </a-button>
    <TagList :tagList="tagListByIptVal"></TagList>
  </div>
  <BasicBtnGroup
    @primeClick="confirm"
    @defClick="cancel"
    class="basic-btns"
  >
    <span slot="defContent">{{$t('common.Cancel')}}</span>
    <span slot="primaryContent">{{$t('common.Ok')}}<span v-if="tagChecked.length">({{tagChecked.length}})</span></span>
  </BasicBtnGroup>
  <AddTag v-model="addTagVisible"></AddTag>
</a-modal>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import TagList from './TagList'
import AddTag from './AddTag'
import BasicBtnGroup from '@/components/behavior/basic-btn-group/index.vue'
const { mapState, mapGetters, mapMutations } = createNamespacedHelpers('tag')

export default {
  name: 'TagModal',
  model: {
    prop: 'visible',
    event: 'change',
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    TagList,
    BasicBtnGroup,
    AddTag,
  },
  data() {
    return {
      addTagVisible: false,
      tagModalClass: []
    }
  },
  computed: {
    ...mapState(['iptVal']),
    ...mapGetters(['tagChecked', 'tagListByIptVal']),
    searchVal: {
      get() {
        return this.iptVal
      },
      set(val) {
        this.setIptVal(val)
      }
    }
  },
  methods: {
    ...mapMutations(['setIptVal']),
    confirm(){
      this.$emit('tagConfirm', this.tagChecked)
      this.$emit('change', false)
    },
    cancel(){
      this.$emit('change', false)
    },
    handleReset() {
      this.setIptVal('')
    },
    addTag() {
      if (this.tagChecked.length === 5) {
        return this.$message.warn(this.$t('home.More5Types'))
      }
      this.addTagVisible = true
    }
  },
}
</script>

<style scoped lang="less">
::v-deep .tag-modal {
  .ant-modal {
    .ant-modal-content {
      height: 507px;
      box-shadow: 0 10px 20px 0 rgba(62, 85, 132, 0.3);
      border-radius: 16px;
      border: 1px solid #EDEFF2;
      .ant-modal-body {
        padding: 32px 32px 24px;
        .search-input input{
          height: 42px;
          background: #EFF3F8;
          box-shadow: 0 0 10px 0 rgba(151, 171, 199, 0.15);
          border-radius: 8px;
          border-color: transparent;
          border-width: 2px;
          font-size: 16px;
          &:hover,&:focus {
            border-color: #236CFF;
            border-right-width: 2px !important;
          }
          &::placeholder {
            font-size: 16px;
            font-weight: 400;
            color: #6a6d73;
          }
        }
        .active {
          .ant-input-prefix {
            display: none;
          }
          input {
            padding-left: 16px;
          }
        }
        .add-btn {
          width: 100%;
          height: 28px;
          border: 1px dashed #91B5FF;
          border-radius: 4px;
          color: #236CFF;
          margin-top: 16px;
          font-size: 14px;
          font-weight: 500;
        }
      }
    }
  }
  .basic-btns {
    width: 100%;
    .default-btn {
      color: #000;
    }
  }
}
</style>
